import { Component, Inject, OnInit } from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollConfiguration } from 'src/app/core/interfaces/interfaces';
import { EmployerService } from 'src/app/core/services/modules/employer.service';
import { SnackBarService } from 'src/app/core/services/utils/snackBar.service';

export interface DialogData {
  title: string;
  payrollConfiguration: PayrollConfiguration;
  CompanyInfoId: string;
}

@Component({
  selector: 'app-dialog-payroll-rules',
  templateUrl: './dialog-payroll-rules.component.html',
  styleUrls: ['./dialog-payroll-rules.component.scss']
})
export class DialogPayrollRulesComponent implements OnInit {

  formRulesPayroll: FormGroup;

  time = [];

  listYesOrNot = [
    {Name: 'SI', Id: true},
    {Name: 'NO', Id: false}
  ];

  listHora = [
    {Name: '1/4 Hora', Id: 0.25},
    {Name: '1/2 Hora', Id: 0.5},
    {Name: '1 Hora', Id: 1},
  ];

  listRound = [
    {Name: 'Sin redondeos', Id: 0},
    {Name: 'Mas cercano', Id: 1},
    {Name: 'Siguiente', Id: 2},
    {Name: 'Anterior', Id: 3},
  ];

  constructor(private dialogRef: MatDialogRef<DialogPayrollRulesComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private employerService: EmployerService,
              private snackBarService: SnackBarService,
              private fb: FormBuilder) {
    this.formRulesPayroll = this.fb.group({
      CompanyInfoId: new FormControl(this.data.CompanyInfoId, Validators.required),

      SlackTimeL: new FormControl('00', Validators.required),
      SlackTimeR: new FormControl('00', Validators.required),
      ExtraTimeL: new FormControl('00', Validators.required),
      ExtraTimeR: new FormControl('00', Validators.required),
      IsRoundDownStartHour: new FormControl(true, Validators.required),
      EarlyEntriesOption: new FormControl(0, Validators.required),
      EarlyEntriesRounding: new FormControl(false, Validators.required),
      SetEarlyEntriesToStartTime: new FormControl(false, Validators.required),
      SetLateLeavesToLeaveTime: new FormControl(false, Validators.required),
      ApplySlackTimeToEntries: new FormControl(false, Validators.required),
      StartHourOption: new FormControl(0, Validators.required),
      StartHourRounding: new FormControl(0, Validators.required),
      IsRoundDownEndHourSlackTime: new FormControl(false, Validators.required),
      EarlyLeaveOption: new FormControl(0, Validators.required),
      EarlyLeaveRounding: new FormControl(0, Validators.required),
      ExtraTimeDiscountL: new FormControl('00', Validators.required),
      ExtraTimeDiscountR: new FormControl('00', Validators.required),
      DiscountL: new FormControl('00', Validators.required),
      DiscountR: new FormControl('00', Validators.required),
      Option: new FormControl(0, Validators.required),
      Rounding: new FormControl(0, Validators.required),
      LeaveOption: new FormControl(0, Validators.required),
      LeaveRouning: new FormControl(0, Validators.required),
      LeaveWithoutScheduleOption: new FormControl(0, Validators.required),
      LeaveWithoutScheduleRounding: new FormControl(0, Validators.required),

    });
    if (this.data.payrollConfiguration !== undefined) {
      // Cualquier bloque (RoundStart, RoundEnd, etc.) puede venir en null cuando la
      // empresa aún no tiene reglas de prenómina configuradas; eso no es un error,
      // así que se completa con los valores por defecto del formulario.
      const roundStart = this.data.payrollConfiguration.RoundStart || ({} as any);
      const roundEnd = this.data.payrollConfiguration.RoundEnd || ({} as any);
      const entryWithoutSchedule = this.data.payrollConfiguration.EntryWithoutSchedule || ({} as any);
      const leaveWithoutSchedule = this.data.payrollConfiguration.LeaveWithoutSchedule || ({} as any);
      const slackTime = this.data.payrollConfiguration.SlackTime || '00:00';
      const extraTime = this.data.payrollConfiguration.ExtraTime || '00:00';
      const extraTimeDiscount = roundEnd.ExtraTimeDiscount || '00:00';
      const discount = leaveWithoutSchedule.Discount || '00:00';

      this.formRulesPayroll.get('SlackTimeL').setValue(slackTime.split(':')[0]);
      this.formRulesPayroll.get('SlackTimeR').setValue(slackTime.split(':')[1]);
      this.formRulesPayroll.get('ExtraTimeL').setValue(extraTime.split(':')[0]);
      this.formRulesPayroll.get('ExtraTimeR').setValue(extraTime.split(':')[1]);
      this.formRulesPayroll.get('SetEarlyEntriesToStartTime').setValue(roundStart.SetEarlyEntriesToStartTime ?? false);
      this.formRulesPayroll.get('EarlyEntriesOption').setValue(roundStart.EarlyEntriesOption ?? 0);
      this.formRulesPayroll.get('EarlyEntriesRounding').setValue(roundStart.EarlyEntriesRounding ?? false);
      this.formRulesPayroll.get('ApplySlackTimeToEntries').setValue(roundStart.ApplySlackTimeToEntries ?? false);
      this.formRulesPayroll.get('StartHourOption').setValue(roundStart.StartHourOption ?? 0);
      this.formRulesPayroll.get('StartHourRounding').setValue(roundStart.StartHourRounding ?? 0);
      this.formRulesPayroll.get('IsRoundDownEndHourSlackTime').setValue(roundEnd.IsRoundDownEndHourSlackTime ?? false);
      this.formRulesPayroll.get('SetLateLeavesToLeaveTime').setValue(roundEnd.SetLateLeavesToLeaveTime ?? false);
      this.formRulesPayroll.get('EarlyLeaveOption').setValue(roundEnd.EarlyLeaveOption ?? 0);
      this.formRulesPayroll.get('EarlyLeaveRounding').setValue(roundEnd.EarlyLeaveRounding ?? 0);
      this.formRulesPayroll.get('LeaveOption').setValue(roundEnd.LeaveOption ?? 0);
      this.formRulesPayroll.get('LeaveRouning').setValue(roundEnd.LeaveRouning ?? 0);
      this.formRulesPayroll.get('ExtraTimeDiscountL').setValue(extraTimeDiscount.split(':')[0]);
      this.formRulesPayroll.get('ExtraTimeDiscountR').setValue(extraTimeDiscount.split(':')[1]);
      this.formRulesPayroll.get('Option').setValue(entryWithoutSchedule.Option ?? 0);
      this.formRulesPayroll.get('Rounding').setValue(entryWithoutSchedule.Rounding ?? 0);
      this.formRulesPayroll.get('LeaveWithoutScheduleOption').setValue(leaveWithoutSchedule.LeaveWithoutScheduleOption ?? 0);
      this.formRulesPayroll.get('LeaveWithoutScheduleRounding').setValue(leaveWithoutSchedule.LeaveWithoutScheduleRounding ?? 0);
      this.formRulesPayroll.get('DiscountL').setValue(discount.split(':')[0]);
      this.formRulesPayroll.get('DiscountR').setValue(discount.split(':')[1]);
    }
    for (let i = 0; i < 60; i++) {
      this.time.push(i < 10 ? '0' + i : i);
    }
  }

  ngOnInit(): void {
    this.setupRoundingToggle('EarlyEntriesOption',   'EarlyEntriesRounding');
    this.setupRoundingToggle('StartHourOption',      'StartHourRounding');
    this.setupRoundingToggle('EarlyLeaveOption',     'EarlyLeaveRounding');
    this.setupRoundingToggle('LeaveOption',          'LeaveRouning');
    this.setupRoundingToggle('Option', 'Rounding');
    this.setupRoundingToggle('LeaveWithoutScheduleOption', 'LeaveWithoutScheduleRounding');
  }

  private setupRoundingToggle(optionKey: string, roundingKey: string) {
    const optCtrl: AbstractControl = this.formRulesPayroll.get(optionKey);
    const rndCtrl: AbstractControl = this.formRulesPayroll.get(roundingKey);

    this.toggleRounding(rndCtrl, optCtrl.value);

    optCtrl.valueChanges.subscribe(val => {
      this.toggleRounding(rndCtrl, val);
    });
  }

  private toggleRounding(ctrl: AbstractControl, optionValue: number) {
    if (optionValue === 0) {
      ctrl.disable({ emitEvent: false });
      ctrl.clearValidators();
      ctrl.setValue(null, { emitEvent: false });
    } else {
      ctrl.enable({ emitEvent: false });
      ctrl.setValidators([Validators.required]);
    }
    ctrl.updateValueAndValidity({ emitEvent: false });
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  changeIsRoundDownStartHour(value) {
    if (value === true) {
      this.formRulesPayroll.get('EarlyEntriesRounding').setValue(0);
    }
  }

  save() {
    const model = {
      CompanyInfoId: this.formRulesPayroll.get('CompanyInfoId').value,
      SlackTime: this.formRulesPayroll.get('SlackTimeR').value,
      ExtraTime: this.formRulesPayroll.get('ExtraTimeR').value,
      RoundStart: {
          StartHourOption: this.formRulesPayroll.get('StartHourOption').value,
          StartHourRounding: this.formRulesPayroll.get('StartHourRounding').value,
          EarlyEntriesOption: this.formRulesPayroll.get('EarlyEntriesOption').value,
          EarlyEntriesRounding: this.formRulesPayroll.get('EarlyEntriesRounding').value ?? 0,
          SetEarlyEntriesToStartTime: this.formRulesPayroll.get('SetEarlyEntriesToStartTime').value,
          ApplySlackTimeToEntries: this.formRulesPayroll.get('ApplySlackTimeToEntries').value,
      },
      RoundEnd: {
          IsRoundDownEndHourSlackTime: this.formRulesPayroll.get('IsRoundDownEndHourSlackTime').value,
          EarlyLeaveOption: this.formRulesPayroll.get('EarlyLeaveOption').value,
          EarlyLeaveRounding: this.formRulesPayroll.get('EarlyLeaveRounding').value,
          SetLateLeavesToLeaveTime: this.formRulesPayroll.get('SetLateLeavesToLeaveTime').value,
          ExtraTimeDiscount: this.formRulesPayroll.get('ExtraTimeDiscountR').value,
          LeaveOption: this.formRulesPayroll.get('LeaveOption').value,
          LeaveRouning: this.formRulesPayroll.get('LeaveRouning').value,
      },
      EntryWithoutSchedule: {
        Rounding: this.formRulesPayroll.get('Rounding').value ?? null,
        Option: this.formRulesPayroll.get('Option').value,
      },
      LeaveWithoutSchedule: {
        LeaveWithoutScheduleRounding: this.formRulesPayroll.get('LeaveWithoutScheduleRounding').value,
        LeaveWithoutScheduleOption: this.formRulesPayroll.get('LeaveWithoutScheduleOption').value,
        Discount: this.formRulesPayroll.get('DiscountR').value,
      },
    };

    if (this.data.payrollConfiguration === undefined) {
      if (this.formRulesPayroll.status === 'VALID') {
        this.employerService.postPayrollConfigurationEmployer(model).subscribe(rest => {
          this.snackBarService.openSnackBar('Configuración guardada', 'X', 4000);
          this.dialogRef.close();
        });
      } else {
        this.snackBarService.openSnackBar('Completa la imformación requerida', 'X', 4000);
        this.formRulesPayroll.markAllAsTouched();
      }
    } else {
      if (this.formRulesPayroll.status === 'VALID') {
        this.employerService.putPayrollConfigurationEmployer(this.data.payrollConfiguration.Id, model).subscribe(rest => {
          this.snackBarService.openSnackBar('Configuración actualizada', 'X', 4000);
          this.dialogRef.close();
        });
      } else {
        this.snackBarService.openSnackBar('Completa la imformación requerida', 'X', 4000);
        this.formRulesPayroll.markAllAsTouched();
      }
    }
  }
}
